import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import TepezzaWrapper from "@components/layouts/tepezzaWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function TepezzaHome(): ReactElement {
    return (
        <TepezzaWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#1e4e35" />
                </div>
                <FormSection iconsFillColor="#1e4e35" />
            </div>
        </TepezzaWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
